<template>
  <!-- Sidebar  -->
  <nav id="sidebar">
    <div class="sidebar-header">
      <div class="brand-name">YeyPass</div>

      <div class="profile-pic">
        <img :src="profilePicture" width="160px" height="auto">
      </div>
      <!-- user name -->
      <div class="username" v-if='!isRequestInProgress'>
        <h3>{{ displayName }}</h3>
        <div v-if="accountType === 'business' && Object.keys(this.currentUser).length !== 0">
          <h5>
            {{ toTitleCase(currentUser.profile_details.full_name) }} -
            {{ currentUser.profile_details.role_in_company }}
          </h5>
        </div>
      </div>
    </div>

    <ul class="list-unstyled components">
      <li v-for="(data, index) in sidebarItems" :key="index">
        <div v-if="accountType === 'individual'">
          <div v-if="(data.user_type === 'both' || data.user_type === 'individual') && !data.is_hidden">
            <router-link :to="data.router">
              <i :class="data.class" :aria-hidden="data.aria_hidden"></i>
              <span>{{ data.title }}</span>
            </router-link>
          </div>
        </div>
        <div v-if="accountType === 'business'">
          <div v-if="(data.user_type === 'both' || data.user_type === 'business') && !data.is_hidden">
            <router-link :to="data.router">
              <i :class="data.class" :aria-hidden="data.aria_hidden"></i>
              <span>{{ data.title }}</span>
            </router-link>
          </div>
        </div>
      </li>

      <li class="" @click="logout()">
        <router-link to="">
          <i class="fa-fw fas fa-cog" aria-hidden="true"></i>
          <span>Logout</span>
        </router-link>
      </li>
    </ul>
  </nav>
</template>

<style scoped src="@/assets/styles/nav-sidebar.css">
</style>

<script>
import { mapGetters } from 'vuex'
import {
  ASSIGN_CURRENT_USER, ASSIGN_CURRENT_COMPANY, LOGOUT
} from '@/store/types/actions.type'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

import { SIDEBAR_ITEMS } from '@/api/constants/Sidebar'

const placeholderImage = 'http://placehold.jp/ebf0f5/9db4cc/150x150.png?text=YP'

const api = new APIService()
const auth = new AuthService()

export default {
  computed: {
    ...mapGetters(['currentUser', 'currentCompany']),
    profilePicture() {
      if(this.accountType === 'business') {
        if(Object.keys(this.currentCompany).length === 0) return placeholderImage
        else return this.currentCompany.company_details.company_logo_url || placeholderImage
      } else if(this.accountType === 'individual') {
        if(Object.keys(this.currentUser).length === 0) return placeholderImage
        else return this.currentUser.profile_details.profile_picture_url || placeholderImage
      }
    },
    displayName() {
      if(this.accountType === 'business')
      return this.toTitleCase(this.currentCompany.company_name) || ''
      else if(this.accountType === 'individual') return auth.getUname()
    }
  },
  data() {
    return {
      userId: auth.getUserId(),
      companyId: auth.getCompanyId(),
      accountType: auth.getAccountType(),
      error: { message: '' },
      sidebarItems: SIDEBAR_ITEMS,
      isRequestInProgress: true
    }
  },
  mounted() {
    this.isRequestInProgress = true
    if (Object.keys(this.currentUser).length === 0 || Object.keys(this.currentCompany).length === 0) {
      if(this.accountType === 'business') this.getCompanyDetails()
      else if(this.accountType === 'individual') this.getUserDetails()
    } else {
      this.isRequestInProgress = false
    }
  },
  methods: {
    toTitleCase(str) {
      return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() })
    },
    async getCompanyDetails() {
      try {
        const company = await api.getCompanyDetails(this.companyId)
        if(company.statusCode !== 400) {
          this.username = this.toTitleCase(company.company_name)

          const filteredUserFromRoles = company.roles.filter(r => r.user_id === this.userId)
          const indiUser = filteredUserFromRoles.length !== 0
          ? filteredUserFromRoles[0].individual_details : {}

          this.$store.dispatch(ASSIGN_CURRENT_USER, indiUser)
          this.$store.dispatch(ASSIGN_CURRENT_COMPANY, company)
        }
        this.isRequestInProgress = false
      } catch (err) {
        this.error.message = err
        this.isRequestInProgress = false
      }
    },
    async getUserDetails() {
      try {
        const user = await api.getUserDetails(this.userId)
        if(user.statusCode !== 400) {
          this.username = this.toTitleCase(user.profile_details.full_name)
          this.$store.dispatch(ASSIGN_CURRENT_USER, user)
        }
        this.isRequestInProgress = false
      } catch (err) {
        this.error.message = err
        this.isRequestInProgress = false
      }
    },
    logout() {
      this.$store.dispatch(LOGOUT)
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.username h3 {
  color: #0091f4;
  padding-left: 0px;
  padding-right: 0px;
}

#sidebar ul li a {
  color: #00386A;
}

#sidebar ul li a .active {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Sidebar.vue